import { CartActionTypes, EMPTY_CART, REMOVE_PRODUCT, UPSERT_PRODUCT } from '../types';
import { IOrderProduct } from '../../types/orderProduct';

export const upsertProductAction = (productOrder: IOrderProduct): CartActionTypes => ({
  type: UPSERT_PRODUCT,
  payload: {
    productOrder,
  },
});

export const removeProductAction = (productOrderId: number): CartActionTypes => ({
  type: REMOVE_PRODUCT,
  payload: {
    productOrderId,
  },
});

export const emptyCartAction = (): CartActionTypes => ({
  type: EMPTY_CART,
});
